// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useProviderServiceRequests } from '@hooks/queries/registry/onboarding/useProviderServiceRequests';
import { ProviderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { useParties } from '../../contexts/PartiesContext';
import TemplateContract from '../../utils/TemplateContract';

export const useInboundProviderServiceRequests = () => {
  const { party } = useParties();
  const transform = (data: TemplateContract<ProviderServiceRequest>[]) => {
    return data.filter((r) => r.payload.provider === party).length;
  };
  return useProviderServiceRequests(transform);
};
